import React from 'react';
import Sup from '../common/sup'
import RemoteText from '../common/remoteText'

export function Disclaimer() {
  return (
    <div className="container mx-auto">
      <div className="py-2 my-2 mt-5 text-sm border-t border-black-400 text-avenue-iron-500">
        <p>
          <Sup>1</Sup> <RemoteText name="Disclaimer1" />
        </p>

        <p>
          <Sup>2</Sup> <RemoteText name="Disclaimer2" />
        </p>
      </div>
    </div>
  )
}
